
// 处理文件下载
export function getCleanFileName(url) {
    // const str = "example.domain.com.something";
    const regex = /(.*)\./;
    const match = url.match(regex);
    if(match && match[1]){
        return match[1]
    }else{
        return url;
    }
}
